module.exports = __webpack_public_path__ + "media/outlook-wizard/Lock-583a30e8.svg";